import {post} from './base.service'

export default{
    /* 彭州全民信息平台数据上报 */
    reportData(params){
        return post('/app/reportdata/submit', params, { withoutLoading: true })
    }
}



// WEBPACK FOOTER //
// ./src/service/reportData.service.js